import { isLoading, isFailed, isComplete } from '@src/global/status';

const isResourceLoading = (data) => isLoading(data.get('loaded'));
const isResourceFailed = (data) => isFailed(data.get('loaded'));
const isResourceComplete = (data) => isComplete(data.get('loaded'));
const getResourceStatus = (data) => data.get('loaded');
const getResourceTotal = (data) => data.get('total');
const getResourcePage = (data) => data.get('page');
const getResourcePerPage = (data) => data.get('perPage');
const getResourceError = (data) => data.get('error');

export {
    isResourceComplete,
    isResourceFailed,
    isResourceLoading,
    getResourceStatus,
    getResourceTotal,
    getResourcePage,
    getResourcePerPage,
    getResourceError,
};
